import { jsx, jsxs } from "react/jsx-runtime";
import { useId, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import classnames from "classnames";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { useImageConverter } from "../../services/hooks/index.js";
import { useIsDesktop } from "../../hooks/index.js";
import { Box } from "../../Box/index.js";
import { CircularProgress } from "../../CircularProgress/index.js";
import { Typography } from "../../Typography/index.js";
import { FileError, Label } from "../common/index.js";
import { Icon } from "../../Icon/index.js";
import { MultipleFileInputPreview } from "./MultipleFileInputPreview.js";
import MultipleFileInput_styles from "./MultipleFileInput.styles.js";
function _async_iterator(iterable) {
    var method, async, sync, retry = 2;
    for("u" > typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new AsyncFromSyncIterator(s);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function MultipleFileInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else MultipleFileInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const getFileKey = (file)=>{
    if ('string' == typeof file.value) return file.value;
    return `${file.value.name}-${file.value.size}-${file.value.lastModified}`;
};
const MultipleFileInput = (_0)=>{
    let { id: htmlId, value, onChange, onBlur = ()=>{}, label, labelIcon, tooltip, required = false, disabled = false, loading = false, validate, cache, error = false, helperText = '', description = 'Загрузите изображение, PDF или DOCX файл', dropzoneText = 'Загрузить ещё', maxLength, withAuth = true, withCounter = true } = _0, rest = _object_without_properties(_0, [
        "id",
        "value",
        "onChange",
        "onBlur",
        "label",
        "labelIcon",
        "tooltip",
        "required",
        "disabled",
        "loading",
        "validate",
        "cache",
        "error",
        "helperText",
        "description",
        "dropzoneText",
        "maxLength",
        "withAuth",
        "withCounter"
    ]);
    const { classes } = MultipleFileInput_styles();
    const reactId = useId();
    const inputId = useMemo(()=>null != htmlId ? htmlId : reactId, [
        htmlId,
        reactId
    ]);
    const imageConverter = useImageConverter();
    const isDesktop = useIsDesktop();
    const theme = useTheme();
    const [isFileLoading, setIsFileLoading] = useState(false);
    const [dropError, setDropError] = useState('');
    const errorToDisplay = dropError ? dropError : helperText;
    const isLoading = loading || isFileLoading;
    const isDisabled = disabled || isLoading;
    const { getRootProps, getInputProps } = useDropzone({
        disabled: isDisabled,
        onDrop: (files)=>_async_to_generator(function*() {
                if (files && files.length) if (cache) {
                    setIsFileLoading(true);
                    setDropError('');
                    const errorText = (yield null == validate ? void 0 : validate(files.map((file)=>({
                            source: file
                        })), {})) || '';
                    if (errorText) {
                        setDropError(errorText);
                        setIsFileLoading(false);
                        return;
                    }
                    const cachedFiles = [];
                    var _iteratorAbruptCompletion = false, _didIteratorError = false, _iteratorError;
                    try {
                        for(var _iterator = _async_iterator(files), _step; _iteratorAbruptCompletion = !(_step = yield _iterator.next()).done; _iteratorAbruptCompletion = false){
                            let _value = _step.value;
                            const file = _value;
                            try {
                                const { file_id: cacheId, expired_at: cacheExpiredAt } = yield cache(file);
                                cachedFiles.push({
                                    value: JSON.stringify({
                                        type: 'file_cache',
                                        id: cacheId,
                                        expiredAt: cacheExpiredAt
                                    }),
                                    source: file
                                });
                            } catch (e) {
                                cachedFiles.push({
                                    value: file,
                                    source: file
                                });
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (_iteratorAbruptCompletion && null != _iterator.return) yield _iterator.return();
                        } finally{
                            if (_didIteratorError) throw _iteratorError;
                        }
                    }
                    onChange([
                        ...value,
                        ...cachedFiles
                    ].slice(0, maxLength));
                    setIsFileLoading(false);
                } else {
                    setIsFileLoading(()=>true);
                    const cachedFiles_0 = files.map((file_0)=>_async_to_generator(function*() {
                            const fileName = file_0.name.toLowerCase();
                            const isHEICByExtension = fileName.endsWith('.heic') || fileName.endsWith('.heif');
                            const isWrongFormat = isHEICByExtension || [
                                'image/heic',
                                'image/heif',
                                'image/heif-sequence',
                                'image/heic-sequence',
                                'image/tiff',
                                'image/dng',
                                'image/x-adobe-dng'
                            ].includes(file_0.type);
                            if (isWrongFormat) {
                                const blob = yield imageConverter.convert(file_0);
                                const convertedFileName = file_0.name.replace(/\.[^.]+$/, '.jpeg');
                                const blobFile = new File([
                                    blob
                                ], convertedFileName, {
                                    type: blob.type
                                });
                                return {
                                    value: blobFile,
                                    source: blobFile
                                };
                            }
                            return {
                                value: file_0,
                                source: file_0
                            };
                        })());
                    Promise.all(cachedFiles_0).then((res)=>{
                        setIsFileLoading(()=>false);
                        return onChange([
                            ...value,
                            ...res
                        ].slice(0, maxLength));
                    });
                }
                else onChange([]);
                onBlur();
            })()
    });
    const isInputHasFiles = !!(null == value ? void 0 : value.length);
    const previews = useMemo(()=>{
        var _value_map;
        return null == (_value_map = value.map) ? void 0 : _value_map.call(value, (file_1, index)=>{
            const removeDocument = ()=>onChange([
                    ...value.slice(0, index),
                    ...value.slice(index + 1)
                ]);
            return /*#__PURE__*/ jsx(MultipleFileInputPreview, {
                file: file_1,
                index: index,
                removeDocument: removeDocument,
                disabled: disabled,
                withAuth: withAuth,
                withCounter: withCounter
            }, getFileKey(file_1));
        });
    }, [
        disabled,
        onChange,
        value,
        withAuth,
        withCounter
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        className: "aqa_multiple_file_input",
        children: [
            label && /*#__PURE__*/ jsx(Label, {
                label: label,
                required: required,
                tooltip: tooltip,
                icon: labelIcon,
                inputId: inputId
            }),
            /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: isDesktop ? '24' : '8',
                width: "100%",
                children: [
                    isInputHasFiles && previews,
                    (!maxLength || value.length < maxLength) && /*#__PURE__*/ jsx(Box, {
                        flexGrow: 1,
                        children: isLoading ? /*#__PURE__*/ jsx(Box, {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: isInputHasFiles ? {
                                xs: 92,
                                md: 140
                            } : '100%',
                            height: {
                                xs: 92,
                                md: 140
                            },
                            bgcolor: "bg.light.primary",
                            border: `${theme.tokens.border.s}px dashed`,
                            borderColor: "stroke.primary",
                            radius: "l",
                            children: /*#__PURE__*/ jsx(CircularProgress, {
                                size: isInputHasFiles ? 30 : 50
                            })
                        }) : /*#__PURE__*/ jsxs("div", _object_spread_props(_object_spread({}, getRootProps()), {
                            children: [
                                /*#__PURE__*/ jsx("input", _object_spread({
                                    id: inputId
                                }, rest, getInputProps())),
                                /*#__PURE__*/ jsxs("div", {
                                    className: classnames(classes.dropzone, isInputHasFiles && classes.dropzoneMini, !isDisabled && classes.active, isDisabled && classes.disabled, (error || dropError) && classes.error),
                                    children: [
                                        /*#__PURE__*/ jsx(Box, {
                                            mb: "4",
                                            fontSize: 32,
                                            height: 32,
                                            children: /*#__PURE__*/ jsx(Icon, {
                                                name: "vkhrtek_file",
                                                size: "32"
                                            })
                                        }),
                                        /*#__PURE__*/ jsx(Box, {
                                            mb: {
                                                xs: '0',
                                                md: '8'
                                            },
                                            children: /*#__PURE__*/ jsx(Typography, {
                                                display: "block",
                                                variant: "caption",
                                                color: isDesktop ? 'text.light.tertirary' : 'original.brand.primary',
                                                align: "center",
                                                children: isInputHasFiles ? dropzoneText : description
                                            })
                                        }),
                                        isDesktop && /*#__PURE__*/ jsx(Button, {
                                            variant: "outlined",
                                            size: "small",
                                            color: "primary",
                                            disabled: disabled,
                                            children: "Загрузить"
                                        })
                                    ]
                                })
                            ]
                        }))
                    })
                ]
            }),
            (error || dropError) && !isFileLoading && /*#__PURE__*/ jsx(FileError, {
                text: errorToDisplay
            })
        ]
    });
};
export { MultipleFileInput };
